<template>
    <base-button-flat
        @click="addToCart"
        :variant="buttonVariant"
        class="rounded-none lg:rounded-sm h-12 lg:h-16 w-full text-sm sm:text-base tracking-widest md:leading-4"
    >
        {{ $t(updateMode ? 'UPDATE_CART' : 'ADD_TO_CART') }}
    </base-button-flat>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButtonFlat from './BaseButtonFlat.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonFlat,
        },

        props: {
            updateMode: Boolean,
        },

        computed: {
            userMadeSelection() {
                return this.customizerStore.userMadeSelection;
            },

            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            hasBackorderedSize() {
                return this.customizerStore.hasBackorderedSize;
            },

            buttonVariant() {
                return this.selectionsComplete && !this.hasBackorderedSize ? 'primary' : 'primaryDisabled';
            },
        },

        methods: {
            addToCart() {
                if (this.selectionsComplete && !this.hasBackorderedSize) {
                    this.customizerStore.setCartErrors(0);
                    this.customizerStore.setErrorState(false);

                    this.customizerStore.addToCartAndExit();
                } else {
                    this.customizerStore.setHasBackorderedError();
                    this.customizerStore.setCartErrors(1);
                    this.customizerStore.setErrorState(true);
                }
            },
        },
    };
</script>
